import styled, { space, SpaceProps } from "../../../../styled";

export const StyledGroup = styled(({ mb, mt, ...rest }) => (
  <div {...rest} />
))<SpaceProps>`
  ${space}
`;
